import React, { useEffect, useState } from "react";
import { useGetRoles } from "../../features/user/network/resolver";

interface IUserLogin {
  id: number;
  name: string;
  username: string;
  email: string;
  role: number;
  status: number;
}

interface IRole {
  key: string;
  value: number;
}

interface UserInformationContextProps {
  get: () => IUserLogin | undefined;
  validateByRole: (role: IContextUserRoleType) => boolean;
  roles: IRole[];
  set: (param: IUserLogin) => void;
}

const userInformationContextDefault: UserInformationContextProps = {
  get: () => {
    return {} as IUserLogin;
  },
  validateByRole: () => true,
  roles: [],
  set: () => {},
};

export const UserInformationStateContext =
  React.createContext<UserInformationContextProps>(
    userInformationContextDefault
  );

const UserInformationContextFC: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [data, setData] = useState<IUserLogin>();
  const [roles, setRoles] = useState<IRole[]>([]);
  const { data: dataRawRole } = useGetRoles();
  const dataRole = dataRawRole?.data.data;

  useEffect(() => {
    if (dataRole) {
      const tempRole = Object.entries(dataRole).map(([key, value]) => ({
        key,
        value,
      }));
      setRoles(tempRole);
    }
  }, [dataRole]);

  function set(param: IUserLogin) {
    setData(param);
  }

  function get() {
    return data;
  }

  function validateByRole(role: IContextUserRoleType) {
    if (data?.role) {
      const roleValue = roles.find((item) => item.key === role);
      const isValid = data?.role === roleValue?.value;
      return isValid;
    }
    return false;
  }

  return (
    <UserInformationStateContext.Provider
      value={{ set, get, validateByRole, roles }}
    >
      {children}
    </UserInformationStateContext.Provider>
  );
};

export type IContextUserRoleType = "Super Admin" | "Admin" | "SPM";

export const useUserInformation = () =>
  React.useContext(UserInformationStateContext);

export default UserInformationContextFC;
